import { render, staticRenderFns } from "./WWDBreadcrumb.vue?vue&type=template&id=08a768e0&scoped=true&lang=pug&"
import script from "./WWDBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./WWDBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./WWDBreadcrumb.vue?vue&type=style&index=0&id=08a768e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a768e0",
  null
  
)

export default component.exports